export default "<app-home></app-home>\r\n<app-footer></app-footer>"